.btn-information{margin:10px 0 0 10px;padding:3px 9px}
/*# sourceMappingURL=country-table.component-VT5E5RU2.css.map */
